import { Alert as DfhAlert } from '@designsforhealth/dfh-react-components'
import { Grid, Typography } from '@material-ui/core'
import styled from 'styled-components'

import LeftHalfLayout from '../../../../layouts/buy/LeftHalfLayout'
import { RewardsInformationTooltip } from '../../../shop/account/rewards/RewardsInformationTooltip'
import ConfirmationContainer from '../../confirmation/ConfirmationContainer'
import TotalSummarySection from '../TotalSummarySection'

export const Heading = styled(Typography)`
  && {
    border-bottom: 1px solid ${({ theme }) => theme.colors.component.checkoutBorderLight};
    padding-bottom: 20px;
    margin-bottom: 15px;

    ${ConfirmationContainer} & {
      border-bottom: none;
      padding-bottom: 0;
    }

    ${LeftHalfLayout} & {
      padding-left: 15px;
      padding-right: 15px;
    }
  }
`

export const RewardsTooltip = styled(RewardsInformationTooltip)`
  color: ${({ theme }) => theme.colors.text.secondary};
`

export const RetailSubtotalSummarySection = styled(TotalSummarySection)`
  color: ${({ theme }) => theme.colors.neutralGray.neutral500};
  span {
    color: ${({ theme }) => theme.colors.neutralGray.neutral500};
  }
`

export const TotalSection = styled(Grid)`
  && {
    border-bottom: 1px solid ${({ theme }) => theme.colors.component.checkoutBorderLight};
    border-top: 1px solid ${({ theme }) => theme.colors.component.checkoutBorderLight};

    margin-bottom: 20px;
    margin-top: 15px;
    padding-bottom: 15px;
    padding-top: 15px;

    ${ConfirmationContainer} & {
      border-bottom: none;
      margin-bottom: 0;
    }

    ${LeftHalfLayout} & {
      padding-left: 15px;
      padding-right: 15px;
    }
  }
`

export const Alert = styled(DfhAlert)`
  && {
    --alert-color: #6c889a;
    --alert-bg-color: ${({ theme }) => theme.colors.grayscale.white};
    > div {
      color: #6c889a;
    }
  }
`

export const Total = styled.span`
  font-family: ${({ theme }) => theme.fontFamilies.gotham};
  font-size: 19px;
  line-height: 30px;
  color: ${({ theme }) => theme.colors.blackPearlBlue.shade700};
  font-weight: 700;
`
